export const SIGN_IN_REQUEST = "SIGN_IN/REQUEST";
export const SIGN_IN_SUCCESS = "SIGN_IN/SUCCESS";
export const SIGN_IN_FAILURE = "SIGN_IN/FAILURE";

export const SIGN_OUT_REQUEST = "SIGN_OUT/REQUEST";
export const SIGN_OUT_SUCCESS = "SIGN_OUT/SUCCESS";
export const SIGN_OUT_FAILURE = "SIGN_OUT/FAILURE";
